module.exports = __webpack_public_path__ + "img/logo-duplicate-killer.13160aa.png";